// extracted by mini-css-extract-plugin
export default {"content":"Qdqb1","container":"+2luH","summary":"Kt0tb","expandIcon":"VonVc","mobile":"IavJJ"};